module.exports = __webpack_public_path__ + "files/152bbf769992ffe1380fad0a664dd5b0.png";